import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// These values are public and can be exposed in the client
const SUPABASE_URL = "https://ogyxrfdxeppixwwoptho.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9neXhyZmR4ZXBwaXh3d29wdGhvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcwNzQyMzcsImV4cCI6MjA1MjY1MDIzN30.mYy8rrkmncQ86hM_w17vkvCVrZUbXy4GGOYBjXGS8Ro";

// Initialize Supabase client with enhanced configuration
export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
    },
    global: {
      headers: {
        'apikey': SUPABASE_ANON_KEY,
        'Content-Type': 'application/json',
      },
    },
  }
);

// Add error handling for fetch operations
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);
    if (!response.ok) {
      console.error('Fetch error:', {
        status: response.status,
        statusText: response.statusText,
        url: args[0],
      });
    }
    return response;
  } catch (error) {
    console.error('Network error:', error);
    throw error;
  }
};

// Initialize auth state listener for debugging
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Auth state changed:', { event, session });
});